import { createGtag } from 'vue-gtag'

export default {
  setup(app, router, prefix, config) {
    // config: provide the whole config or nothing

    console.log('configuring google analytics')
    prefix = prefix || 'default'
    if (config === undefined) {
      const appConfig = JSON.parse(import.meta.env.VITE_APP_FIREBASE)
      config = {
        tagId: appConfig.measurementId,
        pageTracker: {
          router,
          template: (to) => ({
            page_title: `${prefix}: ${to.name}`,
            page_path: to.path,
          }),
        },
      }
    }

    app.use(createGtag(config))
  },
}
